<template>
    <el-tabs style="margin-left: 25px;" v-model="activeName">
        <el-tab-pane style="margin-left: -30px" label="区域" name="region">
            <region v-if="activeName === 'region'"></region>
        </el-tab-pane>
        <el-tab-pane style="margin-left: -30px" label="行业" name="industry" >
            <industry v-if="activeName === 'industry'"></industry>
        </el-tab-pane>
        <el-tab-pane style="margin-left: -30px" label="企业" name="enterprise">
            <enterprise v-if="activeName === 'enterprise'"></enterprise>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import enterprise from './enterprise'
    import industry from './industry'
    import region from './region'
    export default {
        components: {
            enterprise,
            industry,
            region
        },
        data() {
            return {
                activeName: 'region'
            };
        },
        methods: {
        }
    };
</script>